import constants from "../../constants";
import { useState, useEffect, useCallback } from "react";
import { encodeId, getStorage } from "utils";
import { useHistory } from "react-router-dom";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const useTeamConversationState = () => {
  const isChatFromDashBoard = getStorage("isChatFromDashBoard");
  const isFromOwnerOfficeModule = getStorage("isFromOwnerOfficeModule");
  const { profile, isOwner: isAccountOwner, isStaff } = useAccountOwnerCommon();
  const isVendor =
    profile?.role?.systemRole === constants.systemRoles.vendor;

  const cachedChatTab = sessionStorage.getItem(
    constants.localStorageKeys.activeChatTab,
  );
  const [activeTab, setActiveTab] = useState(
    isVendor ? "2" : cachedChatTab || "1",
  );
  useEffect(() => {
    if (isVendor) {
      setActiveTab("2");
      return;
    }
    sessionStorage.setItem(constants.localStorageKeys.activeChatTab, activeTab);
  }, [activeTab, isVendor]);

  const history = useHistory();

  const buildOfficeRoute = useCallback((route, officeId) => {
    return route.replace(":officeId", encodeId(officeId));
  }, []);

  const handleBack = useCallback(() => {
    if (isFromOwnerOfficeModule?.officeSlection) {
      history.push({
        pathname: buildOfficeRoute(
          constants.routes.accountOwner.officeOptions,
          isFromOwnerOfficeModule.officeId,
        ),
      });
      return;
    }

    if (isFromOwnerOfficeModule?.isAdminControl) {
      history.push({
        pathname: buildOfficeRoute(
          constants.routes.staff.officeAdmin,
          isFromOwnerOfficeModule.officeId,
        ),
      });
      return;
    }

    if (isFromOwnerOfficeModule?.staffOfficeSlection) {
      history.push({
        pathname: buildOfficeRoute(
          constants.routes.staff.officeOptions,
          isFromOwnerOfficeModule.officeId,
        ),
      });
      return;
    }

    history.push(
      isVendor
        ? constants.routes.vendor.dashboard
        : isChatFromDashBoard
          ? constants.routes.dashboard.managerDashboard
          : "/",
    );
  }, [
    history,
    isFromOwnerOfficeModule,
    isChatFromDashBoard,
    isVendor,
    buildOfficeRoute,
  ]);

  return {
    state: {
      activeTab,
      isVendor,
      profile: {
        ...profile,
        isAccountOwner,
        isStaff,
        isVendor,
      },
    },
    updateMethods: {
      setActiveTab,
    },
    otherMethods: {
      handleBack,
    },
  };
};

export default useTeamConversationState;
